import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/Footer/footer";
import "./about.css";
import AboutImage from "./Component/AboutImage/aboutImage";
import AboutBACode from "./Component/AboutBACode/AboutBACode";
import VisionMission from "./Component/VisionMission/VisionMission";
import WhyBACode from "./Component/WhyBACode/WhyBACode";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>
          About BA Code Solutions | Web Development Company in Ahmedabad
        </title>

        {/* Meta Description for Search Engines */}
        <meta
          name="description"
          content="Learn about BA Code Solutions, a web development company in Ahmedabad specializing in React websites, modern UI/UX design, and custom digital solutions for businesses."
        />

        {/* Meta Keywords (optional, mostly ignored by Google but fine for other search engines) */}
        <meta
          name="keywords"
          content="about BA Code Solutions, web development company Ahmedabad, react developers India, frontend development company, UI/UX design, custom web solutions"
        />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://bacodesolutions.com/about" />

        {/* Open Graph / Facebook Sharing */}
        <meta property="og:title" content="About BA Code Solutions" />
        <meta
          property="og:description"
          content="Discover our mission, vision, and expertise in building modern web solutions for businesses and startups."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bacodesolutions.com/about" />
        <meta
          property="og:image"
          content="https://bacodesolutions.com/logo192.png"
        />
        <meta property="og:image:alt" content="BA Code Solutions Logo" />
        <meta property="fb:app_id" content="YOUR_FB_APP_ID_HERE" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About BA Code Solutions" />
        <meta
          name="twitter:description"
          content="Explore BA Code Solutions’ mission, vision, and expertise in creating modern web solutions using React."
        />
        <meta
          name="twitter:image"
          content="https://bacodesolutions.com/logo192.png"
        />
        <meta name="twitter:image:alt" content="BA Code Solutions Logo" />
      </Helmet>

      <AboutImage />
      <AboutBACode />
      <VisionMission />
      <WhyBACode />
      <Footer />
    </>
  );
};

export default AboutPage;
